/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestProgressionMilestone } from './QuestProgressionMilestone';
import {
    QuestProgressionMilestoneFromJSON,
    QuestProgressionMilestoneFromJSONTyped,
    QuestProgressionMilestoneToJSON,
    QuestProgressionMilestoneToJSONTyped,
} from './QuestProgressionMilestone';

/**
 * Composition note: exactly ONE bare `$ref` in the allOf, per the repo
 * convention in `.claude/CLAUDE.md`. This carried `$ref: Base` AND
 * `$ref: TimeStamps`; TimeStamps' two fields are inlined below instead.
 * 
 * Scope of the claim, deliberately narrow: the convention says a second
 * bare ref is silently dropped, but the checked-in client generated at
 * openapi-generator 4.3.0 (`client/client/models/QuestProgression.ts`)
 * carries `id`, `createdAt` AND `updatedAt` — so nothing was being lost
 * at that version. This rewrite conforms to the convention; it is not
 * evidence of a bug it fixed.
 * 
 * `name` was also listed as required while no property — and no field on
 * the model — declares it. The 4.3.0 client has no `name`, confirming a
 * required key with nothing behind it generates nothing, so it is gone.
 * 
 * @export
 * @interface QuestProgression
 */
export interface QuestProgression {
    /**
     * 
     * @type {string}
     * @memberof QuestProgression
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof QuestProgression
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof QuestProgression
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof QuestProgression
     */
    userId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof QuestProgression
     */
    isComplete: boolean;
    /**
     * 
     * @type {number}
     * @memberof QuestProgression
     */
    claimedAt?: number;
    /**
     * When the per-user completion-window clock started (stamped once on first observed unlock).
     * @type {number}
     * @memberof QuestProgression
     */
    windowStartedAt?: number;
    /**
     * Per-user completion deadline (windowStartedAt + completionWindowDays). Unset = no window.
     * @type {number}
     * @memberof QuestProgression
     */
    deadlineAt?: number;
    /**
     * Derived at read time (deadlineAt < now && !isComplete). Never stored.
     * @type {boolean}
     * @memberof QuestProgression
     */
    isExpired?: boolean;
    /**
     * 
     * @type {number}
     * @memberof QuestProgression
     */
    lastStatReset?: number;
    /**
     * 
     * @type {string}
     * @memberof QuestProgression
     */
    questConfigId?: string;
    /**
     * 
     * @type {number}
     * @memberof QuestProgression
     */
    pointsReset?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestProgression
     */
    pointsTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestProgression
     */
    pointsLinked?: number;
    /**
     * Map of segment index to entries earned during that segment (for Challenge quests)
     * @type {{ [key: string]: number; }}
     * @memberof QuestProgression
     */
    entriesBySegment?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: QuestProgressionMilestone; }}
     * @memberof QuestProgression
     */
    progression: { [key: string]: QuestProgressionMilestone; };
    /**
     * 
     * @type {{ [key: string]: boolean; }}
     * @memberof QuestProgression
     */
    prerequisites: { [key: string]: boolean; };
}

/**
 * Check if a given object implements the QuestProgression interface.
 */
export function instanceOfQuestProgression(value: object): value is QuestProgression {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('isComplete' in value) || value['isComplete'] === undefined) return false;
    if (!('progression' in value) || value['progression'] === undefined) return false;
    if (!('prerequisites' in value) || value['prerequisites'] === undefined) return false;
    return true;
}

export function QuestProgressionFromJSON(json: any): QuestProgression {
    return QuestProgressionFromJSONTyped(json, false);
}

export function QuestProgressionFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestProgression {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'isComplete': json['isComplete'],
        'claimedAt': json['claimedAt'] == null ? undefined : json['claimedAt'],
        'windowStartedAt': json['windowStartedAt'] == null ? undefined : json['windowStartedAt'],
        'deadlineAt': json['deadlineAt'] == null ? undefined : json['deadlineAt'],
        'isExpired': json['isExpired'] == null ? undefined : json['isExpired'],
        'lastStatReset': json['lastStatReset'] == null ? undefined : json['lastStatReset'],
        'questConfigId': json['questConfigId'] == null ? undefined : json['questConfigId'],
        'pointsReset': json['pointsReset'] == null ? undefined : json['pointsReset'],
        'pointsTotal': json['pointsTotal'] == null ? undefined : json['pointsTotal'],
        'pointsLinked': json['pointsLinked'] == null ? undefined : json['pointsLinked'],
        'entriesBySegment': json['entriesBySegment'] == null ? undefined : json['entriesBySegment'],
        'progression': (mapValues(json['progression'], QuestProgressionMilestoneFromJSON)),
        'prerequisites': json['prerequisites'],
    };
}

export function QuestProgressionToJSON(json: any): QuestProgression {
    return QuestProgressionToJSONTyped(json, false);
}

export function QuestProgressionToJSONTyped(value?: QuestProgression | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'userId': value['userId'],
        'isComplete': value['isComplete'],
        'claimedAt': value['claimedAt'],
        'windowStartedAt': value['windowStartedAt'],
        'deadlineAt': value['deadlineAt'],
        'isExpired': value['isExpired'],
        'lastStatReset': value['lastStatReset'],
        'questConfigId': value['questConfigId'],
        'pointsReset': value['pointsReset'],
        'pointsTotal': value['pointsTotal'],
        'pointsLinked': value['pointsLinked'],
        'entriesBySegment': value['entriesBySegment'],
        'progression': (mapValues(value['progression'], QuestProgressionMilestoneToJSON)),
        'prerequisites': value['prerequisites'],
    };
}

